import React, { ReactNode } from 'react';

export type DropdownBaseLabelProps = {
  children: ReactNode;
};

export const DropdownBaseLabel = ({ children }: DropdownBaseLabelProps) => (
  <>{children}</>
);
